<div class="credential-settings">
  <div class="header-section mb-4">
    <h2>{{ '::Settings:ProductCredentialSetting' | abpLocalization }}</h2>
    <p class="text-muted">Manage cloud credentials for each region</p>
  </div>

  <!-- Product Tabs -->
  <ul class="nav nav-tabs product-tabs mb-4">
    <li *ngFor="let tab of products" class="nav-item">
      <a
        class="nav-link"
        [class.active]="tab === activeTab"
        (click)="activeTab = tab"
        href="javascript:void(0);">
        {{ '::Settings:ProductCredentialSettingProvider:' + tab | abpLocalization }}
      </a>
    </li>
  </ul>

  <!-- Region Cards -->
  <div class="regions-container">
    <div *ngFor="let region of regions; let i = index" class="region-card card mb-4">
      <div class="card-header" (click)="toggleRegionCollapse(i)" style="cursor: pointer;">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="mb-0 region-title">{{ region.displayName || region.name }}</h5>
          <i class="fas" [class.fa-chevron-down]="!isRegionCollapsed(i)" [class.fa-chevron-up]="isRegionCollapsed(i)"></i>
        </div>
      </div>
      <div class="card-body" [class.collapse]="!isRegionCollapsed(i)" [class.show]="isRegionCollapsed(i)">
        <!-- Provider Tabs -->
        <div class="provider-tabs mb-3">
          <button
            *ngFor="let provider of getProvidersForRegion(region.value)"
            type="button"
            class="provider-tab-btn"
            [class.active]="isActiveProvider(activeTab, region.name, provider)"
            (click)="setActiveProvider(activeTab, region.name, provider)">
            {{ getProviderDisplayName(provider) }}
          </button>
        </div>

        <hr class="provider-separator">

        <!-- Provider Form -->
        <form 
          *ngFor="let provider of getProvidersForRegion(region.value)"
          [style.display]="isActiveProvider(activeTab, region.name, provider) ? 'block' : 'none'"
          class="provider-form abp-lg-form" 
          [formGroup]="forms[activeTab][region.name][provider]">
          
          <!-- Enable Settings -->
          <div class="form-check mb-3">
            <input
              type="checkbox"
              class="form-check-input"
              [id]="'checkbox-' + region.name + '-' + provider"
              formControlName="enabled" />
            <label class="form-check-label" [for]="'checkbox-' + region.name + '-' + provider">
              Enable settings
            </label>
          </div>

          <div *ngIf="forms[activeTab][region.name][provider].get('enabled').value" class="provider-fields">
            <!-- URL -->
            <div class="form-group mb-3">
              <label class="form-label" [for]="'url-' + region.name + '-' + provider">
                {{ '::Settings:ProductCredentialSettingProvider:Url' | abpLocalization }} *
              </label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [id]="'url-' + region.name + '-' + provider"
                  formControlName="url" />
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  (click)="copyToClipboard(forms[activeTab][region.name][provider].get('url').value)"
                  title="Copy to clipboard">
                  <i class="fas fa-copy"></i>
                </button>
              </div>
            </div>

            <!-- Identity URL -->
            <div class="form-group mb-3">
              <label class="form-label" [for]="'authEndpoint-' + region.name + '-' + provider">
                {{ '::Settings:ProductCredentialSettingProvider:AuthEndpoint' | abpLocalization }} *
              </label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [id]="'authEndpoint-' + region.name + '-' + provider"
                  formControlName="authEndpoint" />
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  (click)="copyToClipboard(forms[activeTab][region.name][provider].get('authEndpoint').value)"
                  title="Copy to clipboard">
                  <i class="fas fa-copy"></i>
                </button>
              </div>
            </div>

            <!-- Client ID -->
            <div class="form-group mb-3">
              <label class="form-label" [for]="'clientId-' + region.name + '-' + provider">
                {{ '::Settings:ProductCredentialSettingProvider:ClientId' | abpLocalization }} *
              </label>
              <div class="input-group">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  [id]="'clientId-' + region.name + '-' + provider"
                  formControlName="clientId" />
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  (click)="copyToClipboard(forms[activeTab][region.name][provider].get('clientId').value)"
                  title="Copy to clipboard">
                  <i class="fas fa-copy"></i>
                </button>
              </div>
            </div>

            <!-- Client Secret -->
            <div class="form-group mb-3">
              <label class="form-label" [for]="'clientSecret-' + region.name + '-' + provider">
                {{ '::Settings:ProductCredentialSettingProvider:ClientSecret' | abpLocalization }}
              </label>
              <div class="input-group">
                <input
                  [type]="showPassword['clientSecret-' + region.name + '-' + provider] ? 'text' : 'password'"
                  class="form-control form-control-sm"
                  [id]="'clientSecret-' + region.name + '-' + provider"
                  [placeholder]="'::MaskedClientSecretPlaceholder' | abpLocalization"
                  formControlName="clientSecret" />
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  (click)="togglePasswordVisibility('clientSecret-' + region.name + '-' + provider)"
                  title="Toggle password visibility">
                  <i [class]="showPassword['clientSecret-' + region.name + '-' + provider] ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  (click)="copyToClipboard(forms[activeTab][region.name][provider].get('clientSecret').value)"
                  title="Copy to clipboard">
                  <i class="fas fa-copy"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Save Button -->
  <div class="save-section mt-4">
    <abp-button
      (click)="onSubmitForm(activeTab)"
      [disabled]="!isAllEnabledFormsValid(activeTab)">
      <ng-container *ngIf="!loading[activeTab]">
        <i class="fa fa-save"></i>
      </ng-container>
      <ng-container *ngIf="loading[activeTab]">
        <i class="fas fa-spinner fa-spin"></i>
      </ng-container>
      {{ 'AbpUi::Save' | abpLocalization }}
    </abp-button>
  </div>
</div>
